import http from '@utils/http'

/* ===========Start:首页========== */

/*
* 获取sim卡信息
**/
export function getCardUserInfo(data): Promise<any> { // 根据simId获取设备详情
    return http.post('/sim/simInfo', data || {})
}

/*
* 获取sim卡
**/
export function getUrlDeviceInfo(data): Promise<any> { // MP 内根据url绑定会话获取url中设备的基本信息
    return http.post('/sim/initInfo', data || {})
}

/*
* 绑定
**/
export function binding(data): Promise<any> {
    return http.post('/sim/bindSim', data || {})
}
/*
* 激活
**/
export function active(data): Promise<any> {
    return http.post('/sim/simActive', data || {})
}
/*
* 校验沃达丰是否已激活
**/
export function checkActiveStatusVF(data): Promise<any> {
    return http.post('/vodafone/checkActiveStatus', data || {})
}
/*
* 激活沃达丰
**/
export function activeVF(data): Promise<any> {
    return http.post('/vodafone/getActiveUrl', data || {})
}
/*
* 激活
**/
export function getPackageDetail(data): Promise<any> {
    return http.post('/sim/getGoodsReleaseName', data || {})
}
/*
* 激活
**/
export function getCouponReceiveNotice(data): Promise<any> {
    return http.post('/podpage/couponReceiveNotice', data || {})
}
/* 查询是否符合新人礼
**/
export function getqueryMeetingGift(data): Promise<any> {
    return http.post('/sim/queryMeetingGift', data || {})
}
/* ===========End:首页 ========== */

/* ===========Start:登录 ========== */

/*
* 获取验证码
**/
export function getCaptchaUrl(data): string {
    return `https://passport.lenovo.com/capt/1.2/getimage?source=brower:aoac.lenovoconnect.com&lang=zh_CN&t=${data}`
}
/*
* 获取自定义验证码
**/
export function getCaptchaCustomUrl(data): string {
    return `/login/captchaCode?=${data}`
}

/*
* 登录
**/
export function loginByUser(data): Promise<any> {
    return http.post('/login/loginByIdAndPwd', data)
}

/*
* 登录
**/
export function loginByPhone(data): Promise<any> {
    return http.post('/login/loginByMsg', data)
}

/*
* 登录获取短信验证码
**/
export function getLoginMsgCode(data): Promise<any> {
    return http.post('/login/sendMsgForLogin', data)
}

/*
* 注册获取短信验证码
**/
export function getRegisterMsgCode(data): Promise<any> {
    return http.post('/register/sendMsg', data)
}

/*
* 注册
**/
export function registerByUser(data): Promise<any> {
    return http.post('/register', data)
}

/*
* 登出
**/
export function loginOut(data): Promise<any> {
    return http.post('/login/logout', data)
}

export function checkSession(data): Promise<any> {
    return http.post('/login/checkSkip', data)
}

/* ===========End:登录 ========== */

/* ===========Start:实名制 ========== */
export function sendRealName(data): Promise<any> {
    return http.post('/realName/imageRealName', data)
}
/* ===========End:实名制 ========== */

/**
 *
 * @param data 流量详情
 */
export function getCardFlowDetail(data): Promise<any> { // 根据simId流量详情
    return http.post('/sim/obtainTerminalUsage', data || {}, '')
}
export function queryPlanWithOutLogin(data): Promise<any> {
    return http.post('/podpage/queryPlanWithOutLogin', data)
}
export function querySubAreas(data): Promise<any> {
    return http.post('/sim/querySubAreas', data)
}
export function syncQuestionnaire(data): Promise<any> {
    return http.post('/podpage/syncQuestionnaire', data)
}
export function querySelectUpgrade(data): Promise<any> {
    return http.post('/sim/querySelectUpgrade', data)
}
//查询LEN问答功能状态
export function getPadControlFlag(data): Promise<any> {
    return http.post('/question/getPadControlFlag', data)
}
/**
 * 查询用户套餐列表用以充值卡操作
 * @param data
 * @returns {Promise<any>}
 */
export function listPendingRecharge(data): Promise<any> {
    return http.post('/sim/listPendingRecharge', data || {})
}

// 图片上传
export const uploadEditorimg = (data): Promise<any> => http.post('/content/uploadFiles', data)
export const addQuestion = (data): Promise<any> => http.post('/question/addQuestion', data)
export const queryMyQuestion = (data): Promise<any> => http.post('/question/queryMyQuestion', data)